import type { FC } from "react";
import React from "react";

import { CounterInline } from "../../../../../components/CounterInline";
import { createDisplayNameForTextCoreElement } from "../../utils/getDisplayName";
import { createTestIdForTextCoreElement } from "../../utils/getTestId";

import type { CounterInlineProps } from "../../../../../components";
import type { PropsWithCustomColorsStylesNever } from "../../../../../types/react";

import classes from "./TextCoreCounterInline.styl";

type TextCoreCounterInlineProps =
    PropsWithCustomColorsStylesNever<CounterInlineProps>;

export const TEXT_CORE_COUNTER_INLINE_TEST_ID =
    createTestIdForTextCoreElement("counter-inline");

export const TextCoreCounterInline: FC<TextCoreCounterInlineProps> = ({
    customVarsStyles,
    customColorsStyles,
    view = "custom",
    quantity,
    maxQuantity,
}) => {
    return (
        <CounterInline
            data-tsid={TEXT_CORE_COUNTER_INLINE_TEST_ID}
            customVarsStyles={
                customVarsStyles || classes["counter-inline-custom-vars"]
            }
            customColorsStyles={
                customColorsStyles || classes["counter-inline-custom-colors"]
            }
            view={view}
            quantity={quantity}
            maxQuantity={maxQuantity}
        />
    );
};

TextCoreCounterInline.displayName =
    createDisplayNameForTextCoreElement("CounterInline");

export default TextCoreCounterInline;
